<div
  appAddClassModifier
  class="search-modules"
  bluClickOutside
  (clickedOutside)="close()"
>
  @if (formGroupItem) {
    <form [formGroup]="formGroupItem">
      <input
        data-auto-id="search"
        #inputItem
        type="text"
        placeholder="Search for Modules"
        class="search-modules__input"
        [formControl]="getFormControl('search')"
      />
    </form>
  }
  <img
    data-auto-id="closeClick"
    (click)="close()"
    class="search-modules__close"
    [src]="closeImage"
    alt="close icon"
  />
</div>
